import { a as p, j as i, F as b } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as t } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import { T as k } from "../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
const h = 18, s = {
  container: ({
    isDisabled: e,
    descriptionText: o,
    hasBorderBottom: n,
    hasInputField: a,
    isReadOnly: r
  }) => ({
    display: "flex",
    alignItems: !o && !a ? "center" : "start",
    columnGap: 16,
    justifyContent: "flex-start",
    background: t.white200,
    cursor: e || r ? "not-allowed" : "pointer",
    padding: "16px 24px",
    borderBottom: n ? `1px solid ${t.slate200}` : "none"
  }),
  iconWrapper: ({
    descriptionText: e,
    hasInputField: o
  }) => ({
    display: "flex",
    alignItems: "center",
    padding: e || o ? "0 3px 3px 3px" : "3px",
    cursor: "inherit"
  }),
  icon: ({
    isDisabled: e,
    isChecked: o,
    isReadOnly: n
  }) => {
    const a = e ? t.slate300 : n ? t.black : t.blue500, r = e ? o ? t.slate300 : t.white200 : o ? n ? t.black : t.blue500 : t.white200;
    return {
      width: h,
      height: h,
      position: "relative",
      transition: "background 180ms cubic-bezier(0.4, 0, 0.2, 1)",
      borderRadius: `calc(${h}px * 0.125)`,
      border: `2px solid ${a}`,
      background: r,
      boxSizing: "border-box"
    };
  },
  iconPath: ({
    isChecked: e = !1
  }) => ({
    fill: "none",
    stroke: t.white200,
    strokeWidth: "3",
    opacity: e ? "1" : "0",
    strokeDasharray: "30",
    strokeDashoffset: e ? "0" : "30",
    ...e && {
      transition: "stroke-dashoffset 90ms linear 90ms"
    }
  }),
  descriptionText: ({
    descriptionTextState: e
  }) => ({
    color: e === "secondary" ? t.slate400 : t.black,
    fontSize: 12,
    margin: 0
  })
};
function $(e) {
  const {
    isDisabled: o,
    isChecked: n,
    isReadOnly: a,
    label: r,
    onCheckedChange: l,
    descriptionText: c,
    descriptionTextState: m = "primary",
    hasInputField: d = !1,
    hasBorderBottom: f = !1,
    textAreaProps: x
  } = e, u = (y) => {
    !o && !a && (l == null || l(y.target.checked));
  };
  return /* @__PURE__ */ p("label", {
    style: s.container({
      isDisabled: o,
      descriptionText: c,
      hasBorderBottom: f,
      hasInputField: d,
      isReadOnly: a
    }),
    className: o ? void 0 : "checkbox-container",
    children: [/* @__PURE__ */ i("input", {
      "data-testid": typeof r == "string" ? `checkbox-${r.toLowerCase().replace(/ /g, "-")}` : "checkbox",
      type: "checkbox",
      checked: n,
      onChange: u,
      disabled: o,
      readOnly: a,
      style: {
        display: "none"
      }
    }), /* @__PURE__ */ i("div", {
      style: s.iconWrapper({
        descriptionText: c,
        hasInputField: d
      }),
      children: /* @__PURE__ */ i(g, {
        ...e
      })
    }), /* @__PURE__ */ p("div", {
      style: {
        width: "100%"
      },
      children: [c ? /* @__PURE__ */ p(b, {
        children: [r, /* @__PURE__ */ i("p", {
          style: s.descriptionText({
            descriptionTextState: m
          }),
          children: c
        })]
      }) : /* @__PURE__ */ i(b, {
        children: r
      }), d && n && x && /* @__PURE__ */ i("div", {
        style: {
          paddingTop: 16
        },
        children: /* @__PURE__ */ i(k, {
          ...x
        })
      })]
    })]
  });
}
function g(e) {
  return /* @__PURE__ */ i("svg", {
    viewBox: "0 0 24 24",
    style: s.icon(e),
    className: !e.isChecked && !e.isDisabled ? "checkbox-icon" : void 0,
    children: /* @__PURE__ */ i("path", {
      style: s.iconPath(e),
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    })
  });
}
export {
  $ as Checkbox
};
